// Copyright (c) 2022 by Move Closer

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum SidesLayoutColBackground {
  Gray = 'gray',
  None = 'none',
  Primary = 'primary'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const sidesLayoutColBackgroundRegistry: Record<string, string> = {
  [SidesLayoutColBackground.Gray]: '--gray',
  [SidesLayoutColBackground.None]: '--none',
  [SidesLayoutColBackground.Primary]: '--primary'
}
